/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	performPostRequest,
	performPutRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';

export const rankView = (
	viewId: string,
	params: {
		parentType: string;
		parentId: string;
		moveBefore?: {
			viewType: string;
			id: string;
		};
		moveAfter?: {
			viewType: string;
			id: string;
		};
	},
): Promise<void> =>
	performPostRequest(`${getJpdViewsServicePathPrefix()}/v1/views/${viewId}/rank`, {
		body: JSON.stringify(params),
	});

export type CollectionRankViewOptions = {
	collectionUUID: string;
	viewUUID: string;
	parentUUID: string;
	rank: number;
};

export const collectionRankView = ({
	collectionUUID,
	viewUUID,
	parentUUID,
	rank,
}: CollectionRankViewOptions): Promise<void> =>
	performPutRequest(
		`${getJpdViewsServicePathPrefix()}/v1/collections/${collectionUUID}/views/${viewUUID}/rank`,
		{
			body: JSON.stringify({
				rank,
				parent: parentUUID,
			}),
		},
	);
